import { css } from "@emotion/react";

export const container = css`
  position: relative;
`;

export const hiddenInput = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
`;

export const checkMark = css`
  margin: 1rem 0 1.5rem 0;

  // START: Needed for legacy pages

  && ul {
    padding-left: 0;
  }

  // END: Needed for legacy pages
`;

export const listItem = css`
  align-items: baseline;
`;
